export const DESCARTE_MATERIAIS_ATUALIZAR_DATAINI = 'DESCARTE_MATERIAIS_ATUALIZAR_DATAINI';
export const dataInicio = (dataInicio) => ({
  type: DESCARTE_MATERIAIS_ATUALIZAR_DATAINI,
  payload: {
    dataInicio,
  },
});

export const DESCARTE_MATERIAIS_ATUALIZAR_DATAFIM = 'DESCARTE_MATERIAIS_ATUALIZAR_DATAFIM';
export const dataFim = (dataFim) => ({
  type: DESCARTE_MATERIAIS_ATUALIZAR_DATAFIM,
  payload: {
    dataFim,
  },
});

export const DESCARTE_MATERIAIS_ATUALIZAR_TIPOPERIODO = 'DESCARTE_MATERIAIS_ATUALIZAR_TIPOPERIODO';
export const tipoPeriodo = (tipoPeriodo) => ({
  type: DESCARTE_MATERIAIS_ATUALIZAR_TIPOPERIODO,
  payload: {
    tipoPeriodo,
  },
});

export const DESCARTE_MATERIAIS_ATUALIZAR_FILTRO_VALUE = 'DESCARTE_MATERIAIS_ATUALIZAR_FILTRO_VALUE';
export const filtroValue = (filtroValue) => ({
  type: DESCARTE_MATERIAIS_ATUALIZAR_FILTRO_VALUE,
  payload: {
    filtroValue,
  },
});
export const DESCARTE_MATERIAIS_ATUALIZAR_LISTA = 'DESCARTE_MATERIAIS_ATUALIZAR_LISTA';
export const lista = (lista) => ({
  type: DESCARTE_MATERIAIS_ATUALIZAR_LISTA,
  payload: {
    lista,
  },
});
export const DESCARTE_MATERIAIS_ATUALIZAR_PAGE = 'DESCARTE_MATERIAIS_ATUALIZAR_PAGE';
export const page = (page) => ({
  type: DESCARTE_MATERIAIS_ATUALIZAR_PAGE,
  payload: {
    page,
  },
});
export const DESCARTE_MATERIAIS_ATUALIZAR_IMPRIMIR = 'DESCARTE_MATERIAIS_ATUALIZAR_IMPRIMIR';
export const imprimir = (imprimir) => ({
  type: DESCARTE_MATERIAIS_ATUALIZAR_IMPRIMIR,
  payload: {
    imprimir,
  },
});
export const DESCARTE_MATERIAIS_ATUALIZAR_LISTA_DESCARTE = 'DESCARTE_MATERIAIS_ATUALIZAR_LISTA_DESCARTE';
export const listaDescarte = (listaDescarte) => ({
  type: DESCARTE_MATERIAIS_ATUALIZAR_LISTA_DESCARTE,
  payload: {
    listaDescarte,
  },
});


// WEBPACK FOOTER //
// ./src/pages/descarte/tabs/descarte/store/descarte.action.js